import { render, staticRenderFns } from "./batchFirstClaimDialog.vue?vue&type=template&id=8f9c0d9a&scoped=true"
import script from "./batchFirstClaimDialog.vue?vue&type=script&lang=js"
export * from "./batchFirstClaimDialog.vue?vue&type=script&lang=js"
import style0 from "./batchFirstClaimDialog.vue?vue&type=style&index=0&id=8f9c0d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9c0d9a",
  null
  
)

export default component.exports